import { setHandler } from 'src/services/client-app-context';

export class WebClientAppContext {
  /** @type {Function} */
  static messageHandler = null;

  /** @type {IframeElement} */
  static iframe = null;

  /** @type {Function} */
  static onClose = null;

  /**
   * Removes the message event listener from window
   * and resolves the "open" method's promise.
   */
  static close() {
    window.removeEventListener('message', this.messageHandler);
    this.onClose();
  }

  /**
   * Adds the message handler to window.
   *
   * @param {Function} handler
   */
  static onMessage(handler) {
    this.messageHandler = ({ data, origin }) => {
      if (origin === window.location.origin) {
        handler(data);
      }
    };
    window.addEventListener('message', this.messageHandler);
  }

  /**
   * Sets the iframe and the "open" promise resolver (onClose).
   *
   * @param {any} _
   * @param {IframeElement} iframe
   * @returns {Promise}
   */
  static open(_, iframe) {
    this.iframe = iframe;
    return new Promise((resolve) => {
      this.onClose = resolve;
    });
  }

  /**
   * Posts a message to the iframe.
   *
   * @param {String} action
   * @param {any} payload
   */
  static sendMessage(action, payload) {
    if (this.iframe) {
      this.iframe.contentWindow.postMessage({ action, payload }, window.location.origin);
    }
  }
}

/**
 * Sets the client app context handler to the WebClientAppContext.
 */
export default () => {
  setHandler(WebClientAppContext);
};
